import thunk from 'redux-thunk';
import configureMockStore from 'redux-mock-store';
import { updateQueryParams } from '../update-query';
import initialStateForUpdateQuery from './update-query-redux-store';

const mockedStore = configureMockStore([thunk]);

describe('updateQueryParams', () => {
  it('Should update pathname successfully if the query is an object', async () => {
    const query = {
      f_colour: ['black'],
    };
    const store = mockedStore(initialStateForUpdateQuery(false));
    await store.dispatch(updateQueryParams(query));

    const urlData = store.getActions()[0].payload.url;

    expect(urlData).toEqual({
      pathname: 'collections/all-lingerie/colours/black',
      query: {},
    });
  });

  it('Should remove colours from the pathname if no colours are selected', async () => {
    const query = '?test-query';
    const store = mockedStore(initialStateForUpdateQuery(true));
    await store.dispatch(updateQueryParams(query));

    const urlData = store.getActions()[0].payload.url;

    expect(urlData).toEqual('collections/all-lingerie/?test-query');
  });

  it('Should replace existing colours in pathname with new ones', async () => {
    const query = {
      f_colour: ['red', 'blue'],
    };
    const store = mockedStore(initialStateForUpdateQuery(true));
    await store.dispatch(updateQueryParams(query));

    const urlData = store.getActions()[0].payload.url;

    expect(urlData).toEqual({
      pathname: 'collections/all-lingerie/colours/red+blue',
      query: {},
    });
  });

  it('Should preserve query params when moving f_colour to path', async () => {
    const query = {
      f_colour: ['red', 'blue'],
      brand: ['bravissimo'],
    };
    const store = mockedStore(initialStateForUpdateQuery(true));
    await store.dispatch(updateQueryParams(query));

    const urlData = store.getActions()[0].payload.url;

    expect(urlData).toEqual({
      pathname: 'collections/all-lingerie/colours/red+blue',
      query: { brand: ['bravissimo'] },
    });
  });

  it('Should add any colour not being exposed as a faceted nav to the search query instead of the path', async () => {
    const query = {
      f_colour: ['red', 'cream'],
      brand: ['bravissimo'],
    };
    const store = mockedStore(initialStateForUpdateQuery(true));
    await store.dispatch(updateQueryParams(query));

    const urlData = store.getActions()[0].payload.url;

    expect(urlData).toEqual({
      pathname: 'collections/all-lingerie/colours/red',
      query: { brand: ['bravissimo'], f_colour: ['cream'] },
    });
  });
});
